import type { TableDataDto } from '@asset-metrix/portal-gateway-client-js';
import type { AiAssistantDocumentContext } from '@asset-metrix/portal-ui';

import type { TableRowSelection } from '../../store/states/tableRowSelection';
import { getId } from '../table/widgetBulkAction';

function documentLabelFromRow(
  row: TableDataDto['items'][number],
  fallbackId: string
): string {
  const fileName = row.file_name;
  return typeof fileName === 'string' && fileName.trim() !== ''
    ? fileName
    : fallbackId;
}

export function documentContextFromTableRow(
  row: TableDataDto['items'][number]
): AiAssistantDocumentContext | null {
  const id = getId(row);
  if (typeof id === 'string' && id !== '') {
    return { id, label: documentLabelFromRow(row, id) };
  }
  if (typeof id === 'number' && Number.isFinite(id)) {
    const documentId = String(id);
    return { id: documentId, label: documentLabelFromRow(row, documentId) };
  }
  return null;
}

/**
 * Table selections hold plain data rows for most tables; only `docview` rows
 * stand for documents the assistant can work with.
 */
export function documentsFromTableSelection(
  selection: TableRowSelection | null
): AiAssistantDocumentContext[] {
  if (selection?.dataSourceType !== 'docview') {
    return [];
  }

  const documents = [];
  for (const row of selection.rows) {
    const document = documentContextFromTableRow(row);
    if (document != null) {
      documents.push(document);
    }
  }
  return documents;
}
